import CallToAction from "@/components/Button";
import {
  bigLabelTypographicStyle,
  pageTopBackButton,
} from "@/lib/styles/helpers";
import { H1, H2, Small, MainWrapper } from "@/lib/styles";
import { SVGEcoFillSmall } from "@/lib/svg";
import { forwardRef } from "react";
import styled from "styled-components";

export const Container = styled(MainWrapper)`
  ${pageTopBackButton};

  position: relative;
`;

export const Heading = styled.div`
  margin-bottom: 1rem;
  text-transform: uppercase;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  ${({ theme }) => theme.mediaQueries.tablet} {
    margin-bottom: 2.5rem;
  }
`;

export const ProductType = styled.p`
  text-align: center;
  margin: 0 auto 1rem;
  padding: 0.5rem 0;
  font-weight: 700;
  width: fit-content;
  ${bigLabelTypographicStyle}
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Title = styled(H2)`
  text-align: center;
  width: 100%;
`;

export const ProductDataWrapper = styled.div`
  position: relative;
  margin-top: 3.75rem;

  ${({ theme }) => theme.mediaQueries.tablet} {
    display: flex;
    flex-direction: column;
    flex-flow: row wrap;
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-top: 5rem;
  }
`;

export const Parameters = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex: 2;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const ButtonsWrapper = styled.div`
  position: relative;
  margin-top: 2.5rem;
  flex: 1 2rem;

  ${({ theme }) => theme.mediaQueries.tablet} {
    margin-top: 0;
  }
`;

const _Wishlist = forwardRef<HTMLAnchorElement, any>((props, ref) => (
  <CallToAction as="a" ref={ref} variant="primaryBoxed" {...props} />
));

_Wishlist.displayName = "Button";

export const Wishlist = styled(_Wishlist)`
  text-transform: initial;
  margin-bottom: 1.5rem;
  margin-top: 1rem;

  > div {
    margin: 0 0 0 0.6rem;
  }
`;

const _Download = forwardRef<HTMLAnchorElement, any>((props, ref) => (
  <CallToAction as="a" ref={ref} variant="primaryBoxedNegative" {...props} />
));

_Download.displayName = "Button";

export const Download = styled(_Download)`
  text-transform: initial;

  > div {
    margin: 0 0 0 0.6rem;
  }
`;

export const Icon = styled(SVGEcoFillSmall)`
  width: 1em;
`;
